import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@sick-bust-sts/sts-core';

@Component({
  selector: 'app-project-migration',
  templateUrl: './project-migration.component.html',
  styleUrls: [ './project-migration.component.css' ]
})
export class ProjectMigrationComponent implements OnInit {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  ngOnInit() {
    if (!this.authenticationService.isLoggedIn()) {
      this.router.navigate(['login']).then(() => {});
    }
  }
}
